<template>
  <div>
    <div class="max-w-5xl mx-auto">
      <BaseLayoutSpaced relaxed>
        <div>
          <BaseButton primary @click="openModalCreateOrUpdate"> New Provider </BaseButton>
        </div>

        <BaseAdvancedList
          :loading="loading"
          :with-list-header="listHeader"
          :with-list-item="listItem"
          :entities="serviceProviders"
          @edit="editServiceProvider"
          @destroy="openDeleteConfirmationModal"
        />
      </BaseLayoutSpaced>
    </div>

    <portal v-if="modalCreateOrUpdateVisible" to="app-dialog">
      <ModalCreateOrUpdate
        :service-uuid="serviceId"
        :service-provider="serviceProvider"
        @closed="closeModalCreateOrUpdate"
      />
    </portal>

    <portal v-if="modalDeleteConfirmationVisible" to="app-dialog">
      <BaseDialogDelete
        danger
        :custom-classes="'max-w-md'"
        @closed="closeDeleteConfirmationModal"
        @confirmed="destroy"
      />
    </portal>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex';
import ListHeader from '@/components/ServiceProviders/ListHeader.vue';
import ListItem from '@/components/ServiceProviders/ListItem.vue';
import ModalCreateOrUpdate from '@/components/ServiceProviders/ModalCreateOrUpdate.vue';

export default {
  name: 'ServiceProvidersView',

  components: {
    ModalCreateOrUpdate,
  },

  props: {
    serviceId: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    loading: false,
    modalCreateOrUpdateVisible: false,
    modalDeleteConfirmationVisible: false,
  }),

  computed: {
    ...mapState('admin/serviceProviders', ['meta']),

    ...mapGetters('admin/serviceProviders', ['serviceProviders', 'serviceProvider']),

    listHeader() {
      return ListHeader;
    },

    listItem() {
      return ListItem;
    },
  },

  created() {
    this.setup();
  },

  destroyed() {
    this.setCurrent(null);
    this.setIds([]);
    this.setMeta(null);
    this.setLinks(null);
  },

  methods: {
    ...mapActions('admin/serviceProviders', ['fetchServiceProviderList', 'deleteServiceProvider']),

    ...mapMutations('admin/serviceProviders', ['setIds', 'setMeta', 'setLinks', 'setCurrent']),

    async setup() {
      this.loading = true;

      await this.fetchServiceProviderList({ serviceId: this.serviceId });

      this.loading = false;
    },

    openModalCreateOrUpdate(serviceProviderUuid = null) {
      this.setCurrent(serviceProviderUuid);
      this.modalCreateOrUpdateVisible = true;
    },

    closeModalCreateOrUpdate() {
      this.modalCreateOrUpdateVisible = false;
      this.setCurrent(null);
    },

    openDeleteConfirmationModal(serviceProvider) {
      if (!serviceProvider || !serviceProvider.uuid) return;
      this.setCurrent(serviceProvider.uuid);
      this.modalDeleteConfirmationVisible = true;
    },

    closeDeleteConfirmationModal() {
      this.modalDeleteConfirmationVisible = false;
      this.setCurrent(null);
    },

    editServiceProvider(serviceProvider) {
      this.openModalCreateOrUpdate(serviceProvider.uuid);
    },

    async destroy() {
      this.loading = true;

      try {
        await this.deleteServiceProvider({ serviceProviderUuid: this.serviceProvider.uuid });
        this.closeDeleteConfirmationModal();
      } catch (e) {
        //
      }

      this.loading = false;
    },
  },
};
</script>
